import { RiStarFill, RiMoneyDollarCircleFill } from "react-icons/ri";
import { Container, FixcoinValue, FixcoinItem, PopularBadge } from "./styles";

interface IFixcoinCards {
    price: string;
}

interface IFixcoinItensProps {
    fixcoinPrices: IFixcoinCards[];
    setSelectedValue: (price:string) => void;
    setSelectedCard: (index:number) => void;
    selectedCard: number;
}

export function FixcoinItens({ fixcoinPrices, setSelectedValue, setSelectedCard, selectedCard }: IFixcoinItensProps) {

    return (
        <Container>
            {fixcoinPrices.map((card, index) => {
                const isPopular = card.price === "500";
                const isSelected = index === selectedCard;

                return (
                    <FixcoinItem
                        key={index}
                        isSelected={isSelected}
                        isPopular={isPopular}
                        onClick={() => {
                            setSelectedCard(index);
                            setSelectedValue(card.price);
                        }}
                    >
                        {isPopular && (
                            <PopularBadge>
                                <RiStarFill /> Mais escolhido
                            </PopularBadge>
                        )}
                        <FixcoinValue isSelected={isSelected}>
                            <RiMoneyDollarCircleFill 
                                size={24} 
                                color={isSelected ? "var(--white)" : "var(--fixit)"} 
                                style={{ marginRight: '6px' }}
                            />
                            {card.price}
                        </FixcoinValue>
                    </FixcoinItem>
                )
            })}
        </Container>
    )
}